import Splide from "@splidejs/splide";
import "@splidejs/splide/css/core";

/**
 * Helper function to init sliders and make multiple ones on one page possible
 * @param {*} elms Slider elements to initialize
 */
export function createSliders(elms) {
  elms?.forEach((slider) => {
    const splide = new Splide(slider, {
      type: "loop", // Infinite loop slider
      perPage: 1, // One slide per page
      pagination: false, // Disable pagination
      arrows: true, // Enable arrow (controls)
      gap: "2rem", // Gap between slides
    }).mount();
  });
}
